"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));

var _styles = require("@mui/material/styles");

var _Tooltip = _interopRequireWildcard(require("@mui/material/Tooltip"));

var _Help = _interopRequireDefault(require("@mui/icons-material/Help"));

var HtmlTooltip = (0, _styles.styled)(function (_ref) {
  var className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className"]);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], (0, _extends2["default"])({}, props, {
    classes: {
      popper: className
    }
  }));
})(function (_ref2) {
  var theme = _ref2.theme;
  return (0, _defineProperty2["default"])({}, "& .".concat(_Tooltip.tooltipClasses.tooltip), {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  });
});

var Signature = function Signature(_ref4) {
  var checked = _ref4.checked,
      cost = _ref4.cost,
      requireSignature = _ref4.requireSignature,
      condensed = _ref4.condensed;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("label", {
    style: {
      display: 'inline-block'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    style: {
      width: 'auto',
      display: 'inline-block',
      margin: 0
    },
    color: "primary",
    checked: checked,
    onChange: function onChange(e, ch) {
      return requireSignature(ch);
    },
    name: "signature"
  }), /*#__PURE__*/_react["default"].createElement(LabelText, {
    condensed: condensed,
    cost: cost
  })), /*#__PURE__*/_react["default"].createElement(HtmlTooltip, {
    title: /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      variant: "body1",
      style: {
        marginBottom: 20
      }
    }, "The shipping provider will require a signature at the door or leave a door tag to authorize package release.")
  }, /*#__PURE__*/_react["default"].createElement(_Help["default"], null)));
};

var LabelText = function LabelText(_ref5) {
  var condensed = _ref5.condensed,
      cost = _ref5.cost;

  if (condensed) {
    return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
      style: {
        fontSize: '12px',
        display: 'inline-block'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        display: 'inline-block'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        display: 'block'
      }
    }, "Require"), /*#__PURE__*/_react["default"].createElement("span", null, "Signature")), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        verticalAlign: 'middle',
        paddingLeft: '10px'
      }
    }, "- $", cost));
  }

  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "caption",
    style: {
      display: 'inline',
      verticalAlign: 'middle',
      fontWeight: 'bold'
    }
  }, "Require Signature On Delivery - $", cost);
};

var _default = Signature;
exports["default"] = _default;